import type { ReactNode } from 'react';
import { UserOccupation } from 'src/common/constants/user';
export enum CopyType {
  FREE = 'FREE',
  PREMIUM = 'PREMIUM',
}
export type ModalCopy = Record<UserOccupation, {
  title: ReactNode;
  subtitle: ReactNode;
}>;
const DEFAULT_TITLE = () => <>
    Get <span>5 months free</span> with an annual subscription
  </>;
const FREE_OTHER_CARRERS_COPY = 'Invest in your cyber skills this awareness month';
const PREMIUM_OTHER_CARRERS_COPY = 'Make savings and invest in your cyber skills this awareness month';
const STUDENTS_COPY = 'Save big on your studies this cyber security awareness month';
const IT_PRACTITIONER_COPY = 'Add cyber to your IT skillset this awareness month';
const CYBER_PRACTITIONER_COPY = 'Upskill throughout the year, starting this cyber security awareness month';
export const MODAL_COPIES: Record<CopyType, ModalCopy> = {
  [CopyType.FREE]: {
    [UserOccupation.STUDENT]: {
      title: DEFAULT_TITLE(),
      subtitle: STUDENTS_COPY
    },
    [UserOccupation.IT_PRACTITIONER]: {
      title: DEFAULT_TITLE(),
      subtitle: IT_PRACTITIONER_COPY
    },
    [UserOccupation.CYBER_PRACTITIONER]: {
      title: DEFAULT_TITLE(),
      subtitle: CYBER_PRACTITIONER_COPY
    },
    [UserOccupation.NONE]: {
      title: DEFAULT_TITLE(),
      subtitle: FREE_OTHER_CARRERS_COPY
    },
    [UserOccupation.MANAGER]: {
      title: DEFAULT_TITLE(),
      subtitle: FREE_OTHER_CARRERS_COPY
    },
    [UserOccupation.DIRECTOR]: {
      title: DEFAULT_TITLE(),
      subtitle: FREE_OTHER_CARRERS_COPY
    },
    [UserOccupation.OTHER]: {
      title: DEFAULT_TITLE(),
      subtitle: FREE_OTHER_CARRERS_COPY
    }
  },
  [CopyType.PREMIUM]: {
    [UserOccupation.STUDENT]: {
      title: DEFAULT_TITLE(),
      subtitle: STUDENTS_COPY
    },
    [UserOccupation.IT_PRACTITIONER]: {
      title: DEFAULT_TITLE(),
      subtitle: IT_PRACTITIONER_COPY
    },
    [UserOccupation.CYBER_PRACTITIONER]: {
      title: DEFAULT_TITLE(),
      subtitle: CYBER_PRACTITIONER_COPY
    },
    [UserOccupation.NONE]: {
      title: DEFAULT_TITLE(),
      subtitle: PREMIUM_OTHER_CARRERS_COPY
    },
    [UserOccupation.MANAGER]: {
      title: DEFAULT_TITLE(),
      subtitle: PREMIUM_OTHER_CARRERS_COPY
    },
    [UserOccupation.DIRECTOR]: {
      title: DEFAULT_TITLE(),
      subtitle: PREMIUM_OTHER_CARRERS_COPY
    },
    [UserOccupation.OTHER]: {
      title: DEFAULT_TITLE(),
      subtitle: PREMIUM_OTHER_CARRERS_COPY
    }
  }
};
export const getModalCopy = (type: CopyType, occupation: UserOccupation) => {
  return MODAL_COPIES[type][occupation];
};